import { z } from "zod";
import { LicenseRecordSchema } from "./common.js";
import { IdSchema } from "./ids.js";
export const AUDIO_FORMATS = ["pcm_s16le", "wav", "mp3", "opus"];
export const AudioFormatSchema = z.enum(AUDIO_FORMATS);
export const VoiceInfoSchema = z.object({
    id: z.string().min(1),
    providerId: z.string().min(1),
    name: z.string().min(1),
    /** BCP-47 tags, e.g. "tr-TR", "en-US". */
    languages: z.array(z.string().min(2)),
    gender: z.enum(["female", "male", "neutral"]).optional(),
    license: LicenseRecordSchema,
    paid: z.boolean(),
    cloned: z.boolean().optional(),
});
/** The voice a user's assistant speaks with, plus fallbacks (event-sourced user setting). */
export const VoiceSelectionSchema = z.object({
    userId: IdSchema,
    assistantId: IdSchema,
    providerId: z.string().min(1),
    voiceId: z.string().min(1),
    fallback: z.array(z.object({ providerId: z.string().min(1), voiceId: z.string().min(1) })),
});
//# sourceMappingURL=voice.js.map